import { useEffect } from 'react';

// `/` focuses search; with the drawer open, J / K (and the arrows, off a row) step through rows.
// Nothing fires from a field or an antd modal; `/` also stays put inside a popover or the drawer.
export function useTableShortcuts({ searchRef, drawerOpen, onNext, onPrev }) {
  useEffect(() => {
    const onKey = e => {
      const target = e.target;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (target.closest('input, textarea, select, [contenteditable="true"], .ant-modal-wrap')) return;

      if (e.key === '/') {
        if (target.closest('[role="dialog"]')) return;
        e.preventDefault();
        searchRef.current?.focus();
        return;
      }
      if (!drawerOpen) return;
      const onRow = Boolean(target.closest('tr[data-row]'));
      if (e.key === 'j' || (e.key === 'ArrowDown' && !onRow)) {
        e.preventDefault();
        onNext();
      } else if (e.key === 'k' || (e.key === 'ArrowUp' && !onRow)) {
        e.preventDefault();
        onPrev();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [searchRef, drawerOpen, onNext, onPrev]);
}
